<template>
  <div class="container">
    <div class="list-container" :style="{ height: height }">
      <div class="header">配送平台管理</div>
      <div class="toolbar">
        <el-button type="primary" :style="{ marginTop: '15px' }" @click="add">新增配送平台</el-button>
        <el-button type="primary" :style="{ marginTop: '15px' }" @click="handleBind">配送平台绑定</el-button>
        <el-input v-model="keyword" placeholder="查询关键字" :clearable="true" :style="{ width: '250px', marginTop: '15px', float: 'right' }">
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
      </div>
      <div class="content">
        <div v-for="item in ordFreightPlatformList" :key="item.sid" class="item" @click="view(item)">
          <div class="picContainer">
            <div class="pic"></div>
          </div>
          <div class="infoContainer">
            <div class="infoItem" :title="item.cName">{{ item.cName }}</div>
            <div class="infoItem">ID: {{ item.cCode }}</div>
          </div>
        </div>
      </div>
      <el-pagination background :layout="pageLayout" :total="total" :current-page="pageNum" :page-sizes="pageSelect" :page-size="pageSize" :style="{ marginTop: '15px' }" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <AddOrEditPlatformDetail :visible.sync="showAddOrEditPlatformDetail" :sid="currentSid" @close="handleCloseAddOrEditPlatformDetail" />
    <el-dialog title="配送平台绑定" :visible.sync="bindDialogVisable" width="900px" append-to-body>
      <el-row>
        <el-col :span="11">
          <el-radio-group v-model="bindType" @input="handleResetForm">
            <el-radio-button label="1">授权URL方式</el-radio-button>
            <el-radio-button label="2">短信验证方式</el-radio-button>
            <el-radio-button label="3">数据提交方式</el-radio-button>
          </el-radio-group>
          <br />
          <br />
          <el-form ref="form" :model="form" label-width="110px">
            <el-form-item label="填选门店">
              <el-select v-model="form.rstore" filterable placeholder="请选择">
                <el-option v-for="item in storeList" :key="item.sid" :label="item.cname" :value="item.sid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="bindType === '1'" label="配送平台">
              <el-select v-model="form.logistic" filterable placeholder="请选择" @change="handleLogisticChange">
                <el-option label="闪送" value="bingex"></el-option>
                <el-option label="帮啦" value="bangla"></el-option>
                <el-option label="蜂鸟跑腿" value="fengniao"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="bindType === '2'" label="配送平台">
              <el-select v-model="form.logistic" filterable placeholder="请选择" @change="handleLogisticChange">
                <el-option label="裹小递" value="guoxiaodi"></el-option>
                <el-option label="UU跑腿" value="uupt"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="bindType === '3'" label="配送平台">
              <el-select v-model="form.logistic" filterable placeholder="请选择" @change="handleLogisticChange">
                <el-option label="快服务" value="fuwu"></el-option>
                <el-option label="爱跑腿" value="ipaotui"></el-option>
                <el-option label="曹操送" value="caosong"></el-option>
                <el-option label="曹操跑腿" value="caocao"></el-option>
                <el-option label="悟空跑腿" value="wukong"></el-option>
                <el-option label="快跑者" value="keloop"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="bindType !== '1'" label="手机号码">
              <el-input v-model="form.phone" placeholder="请输入手机号" style="width: 200px">
                <i v-if="bindType === '2'" slot="suffix" class="el-input__icon el-icon-mobile-phone" @click="handleGetVerifyCode"></i>
              </el-input>
            </el-form-item>
            <el-form-item v-if="bindType === '2'" label="验证码">
              <el-input v-model="form.verifyCode" clearable placeholder="请输入验证码" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item v-if="bindType === '3'" label="密码/密钥">
              <el-input v-model="form.password" clearable placeholder="请输入密码/密钥" style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="danger" @click="bindDialogVisable = false">取消</el-button>
              <el-button size="small" type="primary" @click="handleSubmitSsw">提交</el-button>
              <el-button v-if="bindType === '1'" size="small" type="success" @click="handleSubmitSswConfirm">我已绑定</el-button>
            </el-form-item>
          </el-form>
          返回报文
          <div class="bcGrey h200 padding10 borderRadius5">
            {{ callbackText }}
            <el-button v-if="bindType === '1' && callbackText !== ''" style="float: right" size="small" type="success" @click="handleCopyCallback">复制链接地址</el-button>
          </div>
        </el-col>
        <el-col :span="12" :offset="1">
          <el-row>
            <el-input v-model="form.storeName" clearable placeholder="门店名称" class="w300">
              <i slot="suffix" class="el-input__icon el-icon-search pointer" @click="handleLogisticChange"></i>
            </el-input>
          </el-row>
          <el-row>
            <el-table ref="storeTable" row-key="ccode" max-height="340px" :data="bindStoreList" style="width: 100%" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
              <el-table-column label="序号" align="center" type="index" width="55" />
              <el-table-column key="ccode" prop="ccode" label="门店编码" />
              <el-table-column key="sstore" prop="sstore" label="门店名称" width="160" />
            </el-table>
          </el-row>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="danger" @click="bindDialogVisable = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getOrdFreightPlatform } from "@/api/delivery/delivery";
import AddOrEditPlatformDetail from "@/views/components/DeliveryPlatform/AddOrEditPlatformDetail";
import clipboard from "@/utils/clipboard.min.js";
export default {
  name: "DeliveryPlatform",
  components: { AddOrEditPlatformDetail },
  data() {
    return {
      height: document.documentElement.clientHeight - 60 + "px",
      currentSid: "",
      showAddOrEditPlatformDetail: false,
      keyword: "",
      ordFreightPlatformList: [],
      loading: false,
      total: 0, //总条数
      pageNum: 1, //当前页
      pageSize: 10, //每页显示条数
      pageSelect: [10, 20, 30, 50],
      pageLayout: "prev, pager, next,jumper,total,sizes",
      bindType: "1",
      bindDialogVisable: false,
      storeList: [],
      bindStoreList: [],
      form: {
        rstore: "",
        sstore: "",
        logistic: "",
        phone: "",
        storeName: "",
        password: ""
      },
      callbackText: "",
    };
  },
  created() {
    this.getOrdFreightPlatform();
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
    this.handleQueryStore();
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    handleResetForm() {
      this.form = {
        rstore: "",
        sstore: "",
        logistic: "",
        phone: "",
        storeName: "",
        password: ""
      };
    },
    handleGetVerifyCode() {
      if (this.form.phone === "") {
        this.$message({ type: "error", message: "请填写手机号" });
      } else if (this.form.rstore === "") {
        this.$message({ type: "error", message: "请选择门店" });
      } else if (this.form.logistic === "") {
        this.$message({ type: "error", message: "请选择平台" });
      }
      this.topsAjax.get(`${this.baseUrls.freightStoreSsw}/sms`, this.form).then((response) => {
        this.callbackText = response;
        this.$message({ type: "success", message: "验证码发送成功" });
      });
    },
    handleCopyCallback() {
      clipboard.copy(JSON.parse(this.callbackText).data.url);
      this.$message({
        type: "success",
        message: "复制成功",
      });
    },
    handleQueryStore() {
      this.topsAjax.get(`${this.baseUrls.orderStore}/queryList`, { bStatus: 2 }).then((response) => {
        this.storeList = response;
      });
    },
    handleSubmitSsw() {
      for (let i = 0; i < this.storeList.length; i++) {
        if (this.form.rstore === this.storeList[i].sid) {
          this.form.ccode = this.storeList[i].ccode;
          this.form.sstore = this.storeList[i].cname;
        }
      }
      this.topsAjax.post(`${this.baseUrls.freightStoreSsw}/submit`, this.form).then((response) => {
        this.callbackText = response.replaceAll("\\", "");
      });
    },
    handleSubmitSswConfirm() {
      for (let i = 0; i < this.storeList.length; i++) {
        if (this.form.rstore === this.storeList[i].sid) {
          this.form.ccode = this.storeList[i].ccode;
          this.form.sstore = this.storeList[i].cname;
        }
      }
      this.topsAjax.post(`${this.baseUrls.freightStoreSsw}/submit/confirm`, this.form).then(() => {
        this.$message({ message: "绑定成功", type: "success" });
        this.handleLogisticChange();
      });
    },
    handleLogisticChange() {
      let url = `${this.baseUrls.freightStoreSsw}/list`;
      this.topsAjax.get(url, { logistic: this.form.logistic, storeName: this.form.storeName }).then((response) => {
        this.bindStoreList = response;
      });
    },
    handleBind() {
      this.bindDialogVisable = true;
    },
    getOrdFreightPlatform() {
      let params = {
        search: this.keyword,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      getOrdFreightPlatform(params)
        .then((result) => {
          if (result) {
            this.ordFreightPlatformList = result.rows;
            this.total = result.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    search() {
      this.pageNum = 1;
      this.getOrdFreightPlatform();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.getOrdFreightPlatform();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getOrdFreightPlatform();
    },
    add() {
      this.currentSid = "";
      this.showAddOrEditPlatformDetail = true;
    },
    view(item) {
      this.currentSid = item.sid;
      this.showAddOrEditPlatformDetail = true;
    },
    handleCloseAddOrEditPlatformDetail() {
      this.showAddOrEditPlatformDetail = false;
      this.pageNum = 1;
      this.getOrdFreightPlatform();
    },
    handleKeydown(event) {
      if (event.key === "Enter" || event.keyCode === 13) {
        this.pageNum = 1;
        this.getOrdFreightPlatform();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding: 20px;
}
.right-container {
  float: left;
  width: calc(100% - 240px);
  height: 100%;
}
.list-container {
  width: 100%;
  border: 1px solid #ddd;
  padding: 0px 20px;
  .header {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    padding-left: 5px;
    border-bottom: 1px solid #ddd;
  }
  .toolbar {
    width: 100%;
    height: 60px;
  }
}
.content {
  width: 100%;
  height: auto;
  overflow: hidden;
  .item {
    width: 240px;
    height: 100px;
    margin: 12px;
    border: 1px solid #ddd;
    border-radius: 5px;
    float: left;
    cursor: pointer;
    .picContainer {
      width: 100px;
      height: 100px;
      float: left;
      .pic {
        width: 70px;
        height: 70px;
        margin: 15px;
        border: 1px solid #ddd;
      }
    }
    .infoContainer {
      width: calc(100% - 100px);
      height: 100px;
      float: left;
      padding: 15px 5px 15px 0px;
      .infoItem {
        width: 100%;
        height: 35px;
        line-height: 35px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.link {
  color: #409eff;
  cursor: pointer;
}
</style>
